module.exports = __webpack_public_path__ + "media/1.a42d05ab.mp3";